import wixWindow from 'wix-window';
import wixLocation from 'wix-location';
import wixSite from 'wix-site';
import wixData from 'wix-data';
import { session } from 'wix-storage';

const JOIN_URL = '/forms/club_membership'

const isEnglish = wixWindow.multilingual.currentLanguage === 'en'
const isMobile = wixWindow.formFactor === "Mobile"

session.setItem("isKatamon", "0");

$w.onReady(async () => {

    // language toggle
    if (isEnglish) {
        $w('#HE').show();
        $w('#EN').hide();

        $w("#barvaz").collapse()
        $w("#barvazEN").expand()
        if (!isMobile) {
            $w("#loginSocialBar1").hide()
        }

        $w("#logo").alt = 'Hapoel Jerusalem FC Logo'
        $w("#logo").tooltip = 'Hapoel Jerusalem FC Logo'
    } else {
        $w('#HE').hide();
        $w('#EN').show();

        $w("#barvaz").expand()
        $w("#barvazEN").collapse()

        $w("#logo").alt = 'סמל מועדון האוהדים הפועל ירושלים'
        $w("#logo").tooltip = 'סמל מועדון האוהדים הפועל ירושלים'
    }

    let language = wixWindow.multilingual.currentLanguage;

    if (language === 'en') {
        if (!isMobile) {
            $w("#menuHe").hide()
            $w("#menuEn").show()
        }
    } else if (language === 'he' && !isMobile && !$w("#menuHe").isVisible) {
        $w("#menuHe").show()
    }

    const membersData = await getMembersCount()

    const countIdEn = isMobile ? 'membersCountENMobile' : 'membersCountEN'
    const countIdHe = isMobile ? 'membersCountHEMobile' : 'membersCountHE'

    const originalTextHE = 'חברי וחברות עמותה עד כה, הקליקו והצטרפו!'
    const originalTextEN = 'club members already joined, join us!'
    $w("#" + countIdHe).text = membersData + " " + originalTextHE
    $w("#" + countIdEn).text = membersData + " " + originalTextEN

    if (isMobile) {
        $w("#membersCounterMobile").expand()
    } else {
        $w("#membersCounter").expand()
        if (!isEnglish) {
            $w("#membersButton").expand()
        }
    }
    const sliderID = isMobile ? 'membersSliderMobile' : 'membersSlider'
    const sliderIDToShow = isEnglish ? sliderID + 'EN' : sliderID
    const sliderIdToHide = isEnglish ? sliderID : sliderID + 'EN'

    $w("#" + sliderIDToShow).onClick(() => { wixLocation.to(JOIN_URL) })

    function counterAnimation() {
        let counterInterval = setInterval(() => {
            const end = parseInt(membersData, 10)
            if (membersCounter <= end && !session.getItem("counterFinished")) {
                $w("#" + sliderIDToShow).value = membersCounter
                membersCounter = membersCounter + 1;
                session.setItem("membersCounter", membersCounter.toString())
            } else {
                session.setItem("counterFinished", "1")
                clearInterval(counterInterval)
            }
        }, 15)
    }

    let membersCounter = 0
    $w('#' + sliderIdToHide).collapse()

    if (session.getItem("counterFinished")) {
        $w("#" + sliderIDToShow).value = parseInt(membersData, 10)
    } else {
        session.removeItem("counterFinished")
        if (session.getItem("membersCounter")) {
            membersCounter = parseInt(session.getItem("membersCounter"), 10)
            $w("#" + sliderIDToShow).value = membersCounter
            counterAnimation()
        } else {
            setTimeout(counterAnimation, 2000)
        }
    }

    if (isEnglish) {

        $w("#" + countIdEn).onClick(() => {
            wixLocation.to(JOIN_URL)
        })
        $w("#" + countIdEn).show()
    } else {

        $w("#" + countIdHe).onClick(() => {
            wixLocation.to(JOIN_URL)
        })
        $w("#" + countIdHe).show()
    }

    // if (session.getItem("isKatamon") === "1") {
    // 	$w("#logo").src = "wix:image://v1/bada06_75910b94bd52471a8bd4e1f4731c0938~mv2.png/%D7%A1%D7%9E%D7%9C%20%D7%9E%D7%95%D7%A2%D7%93%D7%95%D7%9F%20%D7%94%D7%90%D7%95%D7%94%D7%93%D7%99%D7%9D%20%D7%94%D7%A4%D7%95%D7%A2%D7%9C%20%D7%99%D7%A8%D7%95%D7%A9%D7%9C%D7%99%D7%9D.png#originWidth=170&originHeight=170"
    // 	if (isEnglish) {
    // 		$w("#logo").alt = 'Katamon Fans Club Logo'
    // 		$w("#logo").tooltip = 'Katamon Fans Club Logo'
    // 	}
    // 	else {
    // 		$w("#logo").alt = 'סמל עמותת קטמון מועדון אוהדים'
    // 		$w("#logo").tooltip = 'סמל עמותת קטמון מועדון אוהדים'
    // 	}
    // }
    // else if (session.getItem("isKatamon") === "2") {
    // 	console.log(2)
    // 	$w("#logo").src = "wix:image://v1/bada06_1d9344ccd4c3461db1a49940cd45531a~mv2.png/%D7%A1%D7%9E%D7%9C%20%D7%9E%D7%95%D7%A2%D7%93%D7%95%D7%9F%20%D7%94%D7%90%D7%95%D7%94%D7%93%D7%99%D7%9D%20%D7%94%D7%A4%D7%95%D7%A2%D7%9C%20%D7%99%D7%A8%D7%95%D7%A9%D7%9C%D7%99%D7%9D.png#originWidth=170&originHeight=170"
    // 	setInterval(() => {
    // 		$w("#logo").src = "wix:image://v1/bada06_1d9344ccd4c3461db1a49940cd45531a~mv2.png/%D7%A1%D7%9E%D7%9C%20%D7%9E%D7%95%D7%A2%D7%93%D7%95%D7%9F%20%D7%94%D7%90%D7%95%D7%94%D7%93%D7%99%D7%9D%20%D7%94%D7%A4%D7%95%D7%A2%D7%9C%20%D7%99%D7%A8%D7%95%D7%A9%D7%9C%D7%99%D7%9D.png#originWidth=170&originHeight=170"
    // 	}, 1000)
    // 	if (isEnglish) {
    // 		$w("#logo").alt = 'Hapoel Jerusalem FC Logo'
    // 		$w("#logo").tooltip = 'Hapoel Jerusalem FC Logo'
    // 	}
    // 	else {
    // 		$w("#logo").alt = 'סמל מועדון האוהדים הפועל ירושלים'
    // 		$w("#logo").tooltip = 'סמל מועדון האוהדים הפועל ירושלים'
    // 	}
    // }
    // else {
    // 	$w("#logo").src = "wix:image://v1/bada06_a58ef920dfb54fffbff86d5a2a613419~mv2.png/%D7%A1%D7%9E%D7%9C%20%D7%9E%D7%95%D7%A2%D7%93%D7%95%D7%9F%20%D7%94%D7%90%D7%95%D7%94%D7%93%D7%99%D7%9D%20%D7%94%D7%A4%D7%95%D7%A2%D7%9C%20%D7%99%D7%A8%D7%95%D7%A9%D7%9C%D7%99%D7%9D.png#originWidth=170&originHeight=170"
    // 	if (isEnglish) {
    // 		$w("#logo").alt = 'Hapoel Jerusalem FC Logo'
    // 		$w("#logo").tooltip = 'Hapoel Jerusalem FC Logo'
    // 	}
    // 	else {
    // 		$w("#logo").alt = 'סמל מועדון האוהדים הפועל ירושלים'
    // 		$w("#logo").tooltip = 'סמל מועדון האוהדים הפועל ירושלים'
    // 	}
    // }

    // const { path, query } = wixLocation

    // TODO: uncomment when site is live. If it's uncommented the logo will be clickable in the join page
    // $w("#logo").onClick(() => {
    // 	if (language === 'en') {
    // 		wixLocation.to('/home?lang=en')
    // 	}
    // 	if (language === 'he') {
    // 		wixLocation.to('?lang=he')
    // 	}
    // })

    // $w("#HE").onClick(() => {
    //     //console.log('hebrew')
    //     wixLocation.to('/home?lang=he')
    //     wixWindow.multilingual.currentLanguage = "he";
    // })
    // $w("#EN").onClick(() => {
    // 	wixLocation.to('/home?lang=en')
    // 	wixWindow.multilingual.currentLanguage = "en";
    // })

    // $w("#israelFlag").onClick(() => {
    // 	wixWindow.multilingual.currentLanguage = "he";
    // 	// wixLocation.to('?lang=he')
    // })

    // TODO: uncomment when site is live. If it's uncommented the logo will be clickable in the join page
    // $w("#usaFlag").onClick(() => {
    // 		wixLocation.to('/home?lang=en')
    // })

    // $w("#israelFlag").onClick(() => {
    // 		wixLocation.to('/lang=he')
    // })

    // TODO: uncomment when site is live. Currently we disable it so the join page works as expected
    // $w("#logo").onClick(() => {
    // 	if (language === 'en') {
    // 		wixLocation.to('/home?lang=en')
    // 	} else {
    // 		wixLocation.to('/?lang=he')
    // 	}
    // })
});

const getMembersCount = async () => {
    const query = await wixData.query("members_count").find();
    return query.items[0]["count"];
}

/**
 *	Adds an event handler that runs when the element is clicked.
 *	 @param {$w.MouseEvent} event
 */
export function EN_click(event) {
    if (wixSite.currentPage['url'] != '/home') {
        wixLocation.to('/home?lang=en')
    }
    wixWindow.multilingual.currentLanguage = "en";
}

/**
 *	Adds an event handler that runs when the element is clicked.
 *	 @param {$w.MouseEvent} event
 */
export function HE_click(event) {
    if (wixSite.currentPage['url'] != '/home') {
        wixLocation.to('/home?lang=he')
    }
    wixWindow.multilingual.currentLanguage = "he";
}